import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { setAntecedentInfo, setCurrentAnalysisData, setIsProductPage } from "../../../store";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ProductPage from "../DashboardContent/HistoryAnalysis/productPage/productpage";

const FavoriteSku = ({
  analysis_details_id,
  order_details_id,
  switchTab,
  searchQueryForItemsets,
  supportFilter,
  selectedCombo,
  setCountItemSet
}) => {
    
    const [favoriteSkuResponse,setFavoriteSkuResponse] = useState([]);
    const [analysisDetailsResponse,setAnalysisDetailsResponse] = useState([]);
    const [analysisResultFavoriteSkuList, setAnalysisResultFavoriteSkuList] = useState({});
    const [showLoading, setShowLoading] = useState(false);
    const [isClickOnSku,setIsClickOnSku] = useState(false);
    const dispatch = useDispatch()
    const navigate = useNavigate();


    const getFavoriteSkuList = async () => {
        try {
            setShowLoading(true);
            const response = await axios.get(
                `${process.env.REACT_APP_API_END_POINT}/data-analysis/list-favorite-skus?analysis_details_id=${analysis_details_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            setFavoriteSkuResponse(response.data.data)
            setAnalysisDetailsResponse(response.data.analysis_details[0])

            toast.success("Favorite combinations fetched");
            // Use `response.data` here as needed
        } catch (error) {
          if (error.response.data?.detail?.isExpireToken) {
            localStorage.removeItem("token");
            localStorage.removeItem("userInfo");
            navigate("/login")
          }
            toast.error(error.response?.data?.message || error.message);
        } finally {
            setShowLoading(false)
        }
    }

    const markAsSKUFavorite = async (data) => {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_API_END_POINT}/data-analysis/analysis-sku-favorite`,
            data, // no body for PUT query param-based request
            {
              
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          
          toast.success("Favorite updated")
          return data.isFavorite;
        } catch (error) {
          if (error.response.data?.detail?.isExpireToken) {
            localStorage.removeItem("token");
            localStorage.removeItem("userInfo");
            navigate("/login")
          }
          toast.error(error.response?.data || error.message)
          return data.isFavorite; // fallback: unchanged
        }
      };

    const handleToggleSKUFavorite = async (data, isFavorite=false,test,test2) => {
        let skuData = {
            id: data._id,
            isFavorite: !isFavorite
        }
        const newStatus = await markAsSKUFavorite(skuData);
        setAnalysisResultFavoriteSkuList((prev)=>{
            return {
                ...prev,
                [data.sku]: newStatus
            }
        });
      };

    useEffect(()=>{
      if(switchTab === 3){
        getFavoriteSkuList()
      }
    },[switchTab])


    if (showLoading) {
        return <div className="flex justify-center py-10">
            <div className="w-8 h-8 border-4 border-blue-300 border-t-transparent rounded-full animate-spin"></div>
        </div>
    }
  
    return (
      <div className="p-6 ">
        {/* <h2 className="text-2xl font-bold text-gray-800 mb-4">Favorite SKUs</h2> */}
  
        {favoriteSkuResponse.length === 0 ? (
          <div className="text-center text-gray-500 py-10">No favorite SKUs found.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {!isClickOnSku && favoriteSkuResponse.map((item, index) => {
                let isFavorite = analysisResultFavoriteSkuList[item.sku] == undefined ?
                item.isFavorite ? 
                item.isFavorite
                : false
                 : analysisResultFavoriteSkuList[item.sku]
                return (
                    <div key={index} className="flex items-center border p-4 rounded-lg shadow-sm bg-gray-50">
                      <img
                        src={
                          item.image
                              ? item.image
                              : "noimage.jpg"
                          }
                        alt={item.product_title}
                        className="w-16 h-16 rounded object-cover mr-4 border"
                      />
                      <div className="flex-grow">
                        <p className="text-gray-800 font-medium">{item.product_title}</p>
                        <p 
                        className="text-sm text-gray-500 underline cursor-pointer"
                        onClick={() => {
                            setIsClickOnSku(true)
                            dispatch(setAntecedentInfo(item));
                            dispatch(setCurrentAnalysisData(analysisDetailsResponse))
                            dispatch(setIsProductPage(true))
                            // navigate(`/product`, {
                            //     state: {
                            //     order_details_id: order_details_id,
                            //     isSingleOrderExclude: analysisDetailsResponse.isExclude,
                            //     isFavoritePage: true
                            //     },
                            // });
                        }}
                        >{item.sku}</p>
                      </div>
                      <div 
                      className="text-red-500 ml-3 cursor-pointer text-xl"
                      onClick={()=>{handleToggleSKUFavorite(item,isFavorite)}}
                      >
                        <i className={isFavorite ? "fas fa-heart" : "far fa-heart"}></i>
                      </div>
                    </div>
                  )
            })}
            
          </div>
        )}
        {
          isClickOnSku &&
          <ProductPage 
            setIsClickOnSku={setIsClickOnSku}
            isSubComponent={true}
            supportFilter={supportFilter}
            selectedCombo={selectedCombo}
            setCountItemSet={setCountItemSet}
            
          
          />
        }
      </div>
    );
  };
  
  export default FavoriteSku;
  